var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    d: "M14.999,28.464C13.605,27.893,3.634,23.175,3.501,5.36L15,1.527L26.499,5.36 C26.366,23.129,16.392,27.888,14.999,28.464z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M15,2.054l10.995,3.665c-0.249,16.753-9.149,21.42-10.996,22.208 C13.144,27.143,4.252,22.51,4.005,5.719L15,2.054 M15,1L3,5c0,19.998,12,24,12,24s12-4.055,12-24L15,1L15,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M15 7A3 3 0 1 0 15 13 3 3 0 1 0 15 7zM10 19c0-2.761 2.239-5 5-5s5 2.239 5 5H10z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserShield);
export default __webpack_public_path__ + "static/media/user_shield.5da5dcf5.svg";
export { ForwardRef as ReactComponent };